import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { GridService } from 'app/Shared/Services/grid.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { DataService } from 'app/Shared/Services/data.service';
import { UserService } from 'app/Shared/Services/user.service';
import { Exceptions } from 'app/Pages/survillance/common-grid/common-grid.model';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-exception-comment',
    imports: [DialogModule, Select, ButtonModule, ConfirmDialogModule, FormsModule],
    templateUrl: './exception-comment.component.html',
    styleUrls: ['./exception-comment.component.scss']
})
export class ExceptionCommentComponent implements OnInit {
  displayCommentDialog: boolean = true;
  selectedStatus: any = "";
  selectedUser: any = "";
  commentStatement: any = "";
  @Input() userList: any;
  @Input() selectedRow: Array<any> = [];
  status = [
    { label: 'Select Status', value: '' },
    { label: 'Open', value: 'Open' },
    { label: 'Reopen', value: 'Reopen' },
    { label: 'Close', value: 'Close' },
  ];
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updateExceptionStatus: EventEmitter<any> = new EventEmitter();

  constructor(
    public gridService: GridService,
    public constantService: ConstantService,
    public dataService: DataService,
    public userService: UserService) { }

  ngOnInit() {
    this.getDefaultValue();
  }
  getDefaultValue() {
    this.userList.forEach((user: { label: string; value: any; }) => {
      if (this.selectedRow[0].caseOwner!==null &&this.selectedRow[0].caseOwner!=="" && this.selectedRow[0].caseOwner!=undefined && (user.label.toUpperCase() === this.selectedRow[0].caseOwner.toUpperCase())) {
        this.selectedUser = user.value;
      }
    });

    this.selectedUser = this.selectedUser === '' ? this.userService.uid : this.selectedUser;
    this.selectedStatus = this.selectedRow[0].caseStatus ?? (this.selectedRow[0].commentStatus ?? 'Open');
    this.commentStatement = this.selectedRow[0].caseComments ?? (this.selectedRow[0].commentDetails ?? '');
  }
  updateClientDataStaus() {
    let response;
    response = { 'selectedStatus': this.selectedStatus, 'selectedUser': this.selectedUser, 'commentStatement': this.commentStatement, 'selectedRow': this.selectedRow };
    /* Catch User Action Log */
      this.userService.logUserActivity("Added User Comment", null, {
        'Text1': this.userService.userFirstName + ' added Comment',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(response)
      });
    this.updateExceptionStatus.emit(response);
  }

}